import React, { Component } from "react";
import * as pageData from "./PageData";
import Start from "./_1-Start";
import Welcome from "./_2-Welcome";
import Consent from "./_3-Consent";
import TestIntro from "./_4-TestIntro";
import TestFinished from "./_5-TestFinished";
import TestFinished2 from "./_6-TestFinished2";
import TryAgain from "./_7-TryAgain";
import AssessmentFinished from "./_8-AssessmentFinished";
import Comments from "./_9-Comments";
import RemoteComplete from "./_71-RemoteComplete";
import SafetyInstructions from "./01-SafetyInstructions";
import Safety from "./01-Safety";
import InspectionTimeInstructions from "./02-InspectionTimeInstructions";
import InspectionTime from "./02-InspectionTime";
import ShortTermMemoryInstructions from "./03-ShortTermMemoryInstructions";
import ShortTermMemory from "./03-ShortTermMemory";
import SustainedAttentionInstructions from "./04-SustainedAttentionInstructions";
import SustainedAttention from "./04-SustainedAttention";
import LiteracyInstructions from "./05-LiteracyInstructions";
import Literacy from "./05-Literacy";
import NumeracyInstructions from "./06-NumeracyInstructions";
import Numeracy from "./06-Numeracy";
import AbstractReasoningInstructions from "./07-AbstractReasoningInstructions";
import AbstractReasoning from "./07-AbstractReasoning";
import MechanicalReasoningInstructions from "./08-MechanicalReasoningInstructions";
import MechanicalReasoning from "./08-MechanicalReasoning";
import NumericalReasoningInstructions from "./09-NumericalReasoningInstructions";
import NumericalReasoning from "./09-NumericalReasoning";
import VerbalReasoningInstructions from "./10-VerbalReasoningInstructions";
import VerbalReasoning from "./10-VerbalReasoning";
import WpqInstructions from "./11-WpqInstructions";
import Wpq from "./11-Wpq";
import PfiInstructions from "./12-PfiInstructions";
import Pfi from "./12-Pfi";
import PageButtons from "./PageButtons";

var stepSpeechPlayed;

export default class PageContent extends Component {
    static getDerivedStateFromProps(props, state) {
        if (state.step === props.step) {
            return null;
        }

        const content = pageData.getContent(props.step);

        return {
            step: props.step,
            content: content,
            disableNext: content && content.disableNext,
            interceptClick: null
        };
    }

    constructor(props) {
        super(props);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.buttonClick = this.buttonClick.bind(this);
        this.clearDisableNext = this.clearDisableNext.bind(this);
        this.setDisableNext = this.setDisableNext.bind(this);
        this.setInterceptClick = this.setInterceptClick.bind(this);
        this.state = {
            step: 0,
            content: null,
            disableNext: false,
            interceptClick: null
        };
    }

    componentDidMount() {
        this.afterUpdate();
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    afterUpdate() {
        if (stepSpeechPlayed !== this.state.step) {
            stepSpeechPlayed = this.state.step;
            const content = this.state.content;
            if (content && content.elems) {
                this.props.setSpeech(getSpeech(content.elems));
            }
        }
    }

    clearDisableNext() {
        this.setState({ disableNext: false });
    }

    setDisableNext() {
        this.setState({ disableNext: true });
    }

    setInterceptClick(interceptClick) {
        if (this.state.interceptClick !== interceptClick) {
            this.setState({ interceptClick: interceptClick });
        }
    }

    onButtonClick(type) {
        if (this.state.interceptClick && this.state.interceptClick(type) === true) {
            //
        } else {
            this.buttonClick(type);
        }
    }

    buttonClick(type) {
        const p = this.props;

        if (p.devMode === false) {
            try {
                const elem = document.documentElement;
                elem.requestFullscreen = elem.requestFullscreen || elem.mozRequestFullscreen || elem.msRequestFullscreen || elem.webkitRequestFullscreen;
                elem.requestFullscreen();
            } catch (ex) {
                //
            }
        }

        switch (type) {
            case "finish":
            case "next":
                p.next({});
                break;
            case "prev":
            case "back":
                p.cancelSpeech();
                setTimeout(() => {
                    p.previous();
                }, 100);
                break;
            case "skip":
                p.cancelSpeech();
                setTimeout(() => {
                    p.next({});
                }, 100);
                break;
            default:
                break;
        }
    }

    renderButtons(p) {
        const buttonsType = p.content !== null ? p.content.buttonsType || "all" : "all";

        return <PageButtons buttonsType={buttonsType} disableNext={p.disableNext} step={p.step} trainingMode={p.trainingMode} waitingForSpeech={p.waitingForSpeech} buttonClick={this.onButtonClick} />;
    }

    renderPage(p) {
        const step = p.step;
        const waitingForSpeech = p.waitingForSpeech;

        if (step >= pageData.safetyTestFirstPage && step <= pageData.safetyTestLastPage) {
            return <Safety content={p.content} index={p.content.index} next={p.next} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.inspectionTimeTestFirstPage && step <= pageData.inspectionTimeTestLastPage) {
            return <InspectionTime index={p.content.index} clearDisableNext={this.clearDisableNext} next={p.next} setDisableNext={this.setDisableNext} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.shortTermMemoryTestFirstPage && step <= pageData.shortTermMemoryTestLastPage) {
            return <ShortTermMemory devMode={p.devMode} digits={p.content.digits} index={p.content.index} clearDisableNext={this.clearDisableNext} next={p.next} setDisableNext={this.setDisableNext} setInterceptClick={this.setInterceptClick} />;
        } else if (step === pageData.sustainedAttentionTestPage) {
            return <SustainedAttention devMode={p.devMode} clearDisableNext={this.clearDisableNext} next={p.next} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.literacyTestFirstPage && step <= pageData.literacyTestLastPage) {
            return <Literacy content={p.content} clearDisableNext={this.clearDisableNext} next={p.next} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.numeracyTestFirstPage && step <= pageData.numeracyTestLastPage) {
            return <Numeracy content={p.content} clearDisableNext={this.clearDisableNext} next={p.next} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.abstractReasoningTestFirstPage && step <= pageData.abstractReasoningTestLastPage) {
            return <AbstractReasoning index={p.content.index} clearDisableNext={this.clearDisableNext} next={p.next} previous={p.previous} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.mechanicalReasoningTestFirstPage && step <= pageData.mechanicalReasoningTestLastPage) {
            return <MechanicalReasoning content={p.content} clearDisableNext={this.clearDisableNext} next={p.next} previous={p.previous} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.numericalReasoningTestFirstPage && step <= pageData.numericalReasoningTestLastPage) {
            return <NumericalReasoning content={p.content} clearDisableNext={this.clearDisableNext} next={p.next} previous={p.previous} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.verbalReasoningTestFirstPage && step <= pageData.verbalReasoningTestLastPage) {
            return <VerbalReasoning content={p.content} clearDisableNext={this.clearDisableNext} next={p.next} previous={p.previous} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.workProfileQuestionnaireTestFirstPage && step <= pageData.workProfileQuestionnaireTestLastPage) {
            return <Wpq content={p.content} clearDisableNext={this.clearDisableNext} next={p.next} setInterceptClick={this.setInterceptClick} />;
        } else if (step >= pageData.personalFactorsInventoryTestFirstPage && step <= pageData.personalFactorsInventoryTestLastPage) {
            return <Pfi content={p.content} clearDisableNext={this.clearDisableNext} next={p.next} setInterceptClick={this.setInterceptClick} />;
        } else if (step > pageData.pagesPerTest && step % pageData.pagesPerTest === 1) {
            return <TestIntro step={p.step} content={p.content} />;
        } else if (step < pageData.pagesPerTest || step % pageData.pagesPerTest === 2) {
            switch (step) {
                case pageData.tryLater:
                    return <TryAgain />;
                case pageData.startPage:
                    return <Start />;
                case pageData.consentPage:
                    return <Consent content={p.content} />;
                case pageData.welcomePage:
                    return <Welcome content={p.content} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} speechPlaying={p.speechPlaying} />;
                case pageData.lastTestFinishedPage:
                    return <TestFinished2 />;
                case pageData.assessmentFinishedPage:
                    return <AssessmentFinished next={p.next} setInterceptClick={this.setInterceptClick} verifyPassword={p.verifyPassword} />;
                case pageData.commentsPage:
                    return <Comments clearDisableNext={this.clearDisableNext} next={p.next} setInterceptClick={this.setInterceptClick} />;
                case pageData.remoteComplete:
                    try {
                        if (document.exitFullscreen) {
                            document.exitFullscreen();
                        } else if (document.webkitExitFullscreen) {
                            document.webkitExitFullscreen();
                        } else if (document.mozCancelFullScreen) {
                            document.mozCancelFullScreen();
                        } else if (document.msExitFullscreen) {
                            document.msExitFullscreen();
                        }
                    } catch (ex) {
                        //
                    }
                    return <RemoteComplete clearDisableNext={this.clearDisableNext} next={p.next} setInterceptClick={this.setInterceptClick} />;
                case pageData.safetyTestInstructions:
                    return <SafetyInstructions content={p.content} clearDisableNext={this.clearDisableNext} playSpeechForInstructionEnd={p.playSpeechForInstructionEnd} waitingForSpeech={waitingForSpeech} />;
                case pageData.inspectionTimeTestInstructions:
                    return <InspectionTimeInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} playSpeechForInstructionEnd={p.playSpeechForInstructionEnd} waitingForSpeech={waitingForSpeech} />;
                case pageData.shortTermMemoryTestInstructions:
                    return <ShortTermMemoryInstructions devMode={p.devMode} content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} playSpeechForInstructionEnd={p.playSpeechForInstructionEnd} waitingForSpeech={waitingForSpeech} />;
                case pageData.sustainedAttentionTestInstructions:
                    return <SustainedAttentionInstructions devMode={p.devMode} content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} playSpeechForInstructionEnd={p.playSpeechForInstructionEnd} waitingForSpeech={waitingForSpeech} />;
                case pageData.literacyTestInstructions:
                    return <LiteracyInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} waitingForSpeech={waitingForSpeech} />;
                case pageData.numeracyTestInstructions:
                    return <NumeracyInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} waitingForSpeech={waitingForSpeech} />;
                case pageData.abstractReasoningTestInstructions:
                    return <AbstractReasoningInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} waitingForSpeech={waitingForSpeech} />;
                case pageData.mechanicalReasoningTestInstructions:
                    return <MechanicalReasoningInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} waitingForSpeech={waitingForSpeech} />;
                case pageData.numericalReasoningTestInstructions:
                    return <NumericalReasoningInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} setDisableNext={this.setDisableNext} waitingForSpeech={waitingForSpeech} />;
                case pageData.verbalReasoningTestInstructions:
                    return <VerbalReasoningInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} waitingForSpeech={waitingForSpeech} />;
                case pageData.workProfileQuestionnaireTestInstructions:
                    return <WpqInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} waitingForSpeech={waitingForSpeech} />;
                case pageData.personalFactorsInventoryTestInstructions:
                    return <PfiInstructions content={p.content} clearDisableNext={this.clearDisableNext} currentTabId={p.currentTabId} setCurrentTab={p.setCurrentTab} waitingForSpeech={waitingForSpeech} />;
                default:
                    return null;
            }
        } else {
            switch (step) {
                case pageData.safetyTestCompletedPage:
                case pageData.inspectionTimeTestCompletedPage:
                case pageData.shortTermMemoryTestCompletedPage:
                case pageData.sustainedAttentionTestCompletedPage:
                case pageData.literacyTestCompletedPage:
                case pageData.numeracyTestCompletedPage:
                case pageData.abstractReasoningTestCompletedPage:
                case pageData.mechanicalReasoningTestCompletedPage:
                case pageData.numericalReasoningTestCompletedPage:
                case pageData.verbalReasoningTestCompletedPage:
                case pageData.workProfileQuestionnaireTestCompletedPage:
                case pageData.personalFactorsInventoryTestCompletedPage:
                    return <TestFinished testName={p.content.testName} />;
                default:
                    return null;
            }
        }
    }

    render() {
        const p = { ...this.props, content: this.state.content, disableNext: this.state.disableNext };

        return (
            <div className="test-page-content-outer">
                <div>
                    {this.renderPage(p)}
                    {this.renderButtons(p)}
                </div>
            </div>
        );
    }
}

function getSpeech(elems) {
    let arr = elems.map(function (item) { return getSpeechItems(item); });

    arr = arr.reduce(function (accumulator, item) {
        if (Array.isArray(item)) {
            return [...accumulator, ...item];
        }
        return accumulator.concat(item);
    }, []);

    arr = arr.filter(item => item.text !== undefined || item.items !== undefined);

    return arr;
}

function getSpeechItems(item) {
    if (item.type === "g") {
        return item.elems.map(function (i) { return getSpeechItems(i); });
    }

    if (item.type === "t") {
        const tabs = item.elems.map(function (tab) {
            const items = getSpeech(tab.elems);

            return { tabId: tab.tabId, items: items };
        });

        return tabs;
    }

    return { text: item.text };
}
